export const airIndexes = {
  'en': {
    'co2': {
      'name': 'CO₂ (ppm)',
      'keyName': 'co2',
      'displayValues': [
        0,
        500,
        1000,
        1500,
        2000
      ]
    },
    'voc_v1': {
      'name': 'VOCs (ppb)',
      'keyName': 'voc_v1',
      'displayValues': [
        0,
        250,
        500,
        750,
        1000
      ]
    },
    'voc': {
      'name': 'VOCs (ppb)',
      'keyName': 'voc',
      'displayValues': [
        0,
        500,
        1000,
        1500,
        2000
      ]
    },
    'dust': {
      'name': 'dust (µg/m³)',
      'keyName': 'dust',
      'displayValues': [
        0,
        15,
        30,
        45,
        60
      ]
    },
    'pm25': {
      'name': 'PM2.5 (µg/m³)',
      'keyName': 'pm25',
      'displayValues': [
        0,
        20,
        40,
        60,
        80
      ]
    }
  },
  'ko': {
    'co2': {
      'name': '이산화탄소 (ppm)',
      'keyName': 'co2',
      'displayValues': [
        0,
        500,
        1000,
        1500,
        2000
      ]
    },
    'voc_v1': {
      'name': '화학물질 (ppb)',
      'keyName': 'voc_v1',
      'displayValues': [
        0,
        250,
        500,
        750,
        1000
      ]
    },
    'voc': {
      'name': '화학물질 (ppb)',
      'keyName': 'voc',
      'displayValues': [
        0,
        500,
        1000,
        1500,
        2000
      ]
    },
    'dust': {
      'name': '미세먼지 (µg/m³)',
      'keyName': 'dust',
      'displayValues': [
        0,
        15,
        30,
        45,
        60
      ]
    },
    'pm25': {
      'name': '초미세먼지 (µg/m³)',
      'keyName': 'pm25',
      'displayValues': [
        0,
        20,
        40,
        60,
        80
      ]
    }
  }
};

export const colorPalette = {
  awairRed: '#E73740',
  awairGreen: '#4FCC53',
  awairBlue: '#64C2E6',
  awairYellowL: '#FCD03D',
  awairYellowM: '#F9A91B',
  awairYellowD: '#F78725',
  awairGray0: '#F8F9FA',
  awairGray1: '#F1F3F4',
  awairGray2: '#E9ECEE',
  awairGray3: '#DEE2E5',
  awairGray4: '#CDD3D8',
  awairGray5: '#ACB4BB',
  awairGray6: '#868D94',
  awairGray7: '#495056',
  awairGray8: '#343A3E',
  awairGray9: '#212528'
};


// WEBPACK FOOTER //
// ./src/lib/variables.js